import $ from "jquery";

const ActiveStateForMenu = (element, type) => {
    let $element;
    if (type === "header") {
        $element = $(element)
    } else {
        $element = $(element).find("a");
    }

    const currentUrl = window?.location.href;
    const href = $element.attr("href");
    const isCurrentPage = (url, link) => {
        const linkUrl = new URL(link, window.location.origin);
        return url.includes(linkUrl.pathname);
    };
    if (type === "navbar") {

        if (
            currentUrl.includes("/affarsomraden") &&
            $element[0]?.href.includes("/vara-tjanster")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (
            currentUrl.includes("/kompetensomraden") &&
            $element[0]?.href.includes("/vara-tjanster")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (
            currentUrl.includes("/evenemang") &&
            $element[0]?.href.includes("/news")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }
        if (
            currentUrl.includes("/artiklar") &&
            $element[0]?.href.includes("/news")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (currentUrl.includes("/aktuellt") && $element[0]?.href.includes("/news")) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (
            currentUrl.includes("/medarbetare") &&
            $element[0]?.href.includes("/coworkers")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (
            currentUrl.includes("/lediga-jobb/") &&
            $element[0]?.href.includes("/karriar")
        ) {
            $element.parent().addClass("menu-main__item--current");
        }

        if (isCurrentPage(currentUrl, href)) {
            $element.parent().addClass("menu-main__item--current");
        }

    } else if (type === "header") {

        if (
            currentUrl.includes("/business-areas") &&
            $element[0]?.href.includes("/vara-tjanster/")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (
            currentUrl.includes("/kompetensomraden") &&
            $element[0]?.href.includes("/vara-tjanster")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (
            currentUrl.includes("/evenemang") &&
            $element[0]?.href.includes("/news")
        ) {
            $element.addClass("header-menu__large-link");
        }
        if (
            currentUrl.includes("/artiklar") &&
            $element[0]?.href.includes("/news")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (currentUrl.includes("/aktuellt") &&
            $element[0]?.href.includes("/news")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (
            currentUrl.includes("/medarbetare") &&
            $element[0]?.href.includes("/coworkers")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (
            currentUrl.includes("/lediga-jobb/") &&
            $element[0]?.href.includes("/karriar")
        ) {
            $element.addClass("header-menu__large-link--current");
        }

        if (isCurrentPage(currentUrl, href)) {
            $element.addClass("header-menu__large-link--current");
        }

    }
};

export default ActiveStateForMenu;
